// AUTO-GENERATED from the legacy PHP portal (lang/mr.php). 392 keys.
// Regenerate with: npm run i18n:sync  (see tools/sync-lang.mjs)

import type { TranslationKey } from './en.js';

export const mr: Partial<Record<TranslationKey, string>> = {
  "org_name": "पुणे महानगरपालिका",
  "dept_name": "मालमत्ता कर विभाग",
  "nav_home": "मुख्यपृष्ठ",
  "nav_about": "आमच्याबद्दल",
  "nav_faqs": "प्रश्नोत्तरे",
  "nav_contact": "संपर्क",
  "nav_calculator": "कर कॅल्क्युलेटर",
  "nav_signin": "साइन इन / नोंदणी",
  "nav_dashboard": "माझा डॅशबोर्ड",
  "nav_logout": "बाहेर पडा",
  "hero_kicker": "तुमचा मालमत्ता कर ऑनलाइन भरा",
  "hero_title_1": "जलद, सोपे आणि",
  "hero_title_2": "सुरक्षित",
  "hero_tagline": "तुमच्या मालमत्ता कराचे व्यवस्थापन करण्यासाठी फक्त काही क्लिक पुरेसे आहेत",
  "search_ph": "मालमत्ता क्रमांक शोधा",
  "search_btn": "शोधा",
  "sample": "उदाहरण",
  "feat_search_t": "तुमची मालमत्ता शोधा",
  "feat_search_d": "मालमत्ता क्रमांक (PID) वापरून तुमची मालमत्ता त्वरित शोधा आणि संपूर्ण तपशील पहा.",
  "feat_pay_t": "सुरक्षित ऑनलाइन पेमेंट",
  "feat_pay_d": "UPI, क्रेडिट/डेबिट कार्ड किंवा नेट बँकिंगद्वारे पैसे भरा आणि लगेच पावती मिळवा.",
  "feat_calc_t": "तुमच्या कराचा अंदाज घ्या",
  "feat_calc_d": "तुमच्या वार्षिक मालमत्ता कराच्या अंदाजासाठी कर कॅल्क्युलेटर वापरा.",
  "feat_hist_t": "पेमेंट इतिहास पहा",
  "feat_hist_d": "सर्व मागील बिले, पेमेंट पहा आणि पावत्या कधीही डाउनलोड करा.",
  "search_title": "मालमत्ता शोधा",
  "search_results": "शोध निकाल",
  "no_results": "प्रविष्ट केलेल्या मालमत्ता क्रमांकासाठी कोणतीही मालमत्ता आढळली नाही. कृपया तुमच्या मागील बिलावरील PID तपासा आणि पुन्हा प्रयत्न करा.",
  "view_details": "तपशील पहा",
  "property_details": "मालमत्तेचा तपशील",
  "pid": "मालमत्ता क्रमांक (PID)",
  "old_pid": "जुना मालमत्ता क्रमांक",
  "prop_type": "मालमत्तेचा प्रकार",
  "ward": "प्रभाग",
  "zone": "क्षेत्र",
  "peth": "पेठ / विभाग",
  "address": "पत्ता",
  "status": "स्थिती",
  "owners": "मालक",
  "owner_name": "मालकाचे नाव",
  "owner_share": "हिस्सा %",
  "primary": "मुख्य",
  "dues_summary": "सध्याची थकबाकी",
  "total_outstanding": "एकूण थकबाकी",
  "no_dues": "कोणतीही थकबाकी नाही. सर्व बिले भरलेली आहेत.",
  "view_bills": "बिले पहा",
  "view_history": "पेमेंट इतिहास",
  "bills_title": "मालमत्ता कर बिले",
  "bill_no": "बिल क्रमांक",
  "bill_date": "बिल दिनांक",
  "due_date": "देय दिनांक",
  "period": "कालावधी",
  "bill_amount": "बिल रक्कम",
  "paid": "भरलेले",
  "outstanding": "थकबाकी",
  "action": "कृती",
  "view": "पहा",
  "pay_now": "आता भरा",
  "no_bills": "या मालमत्तेसाठी कोणतीही बिले आढळली नाहीत.",
  "no_bills_pending_note": "अद्याप कोणतीही बिले तयार झालेली नाहीत. खाली एक प्रलंबित अर्ज आहे ज्यामुळे तुमचे पहिले मूल्यांकन होऊ शकते.",
  "no_tax_breakdown": "सध्याच्या बिलासाठी कर-शीर्ष विभाजन उपलब्ध नाही.",
  "of_bill": "बिलाचा",
  "ward_benchmark_title": "तुमची तुलना",
  "you": "तुम्ही",
  "ward_average": "प्रभाग सरासरी",
  "citywide_average": "शहरव्यापी सरासरी",
  "benchmark_note_lower": "तुम्ही बहुतांश तुलनायोग्य मालमत्तांपेक्षा प्रति चौ.फूट कमी कर भरत आहात",
  "benchmark_note_higher": "तुम्ही बहुतांश तुलनायोग्य मालमत्तांपेक्षा प्रति चौ.फूट जास्त कर भरत आहात",
  "compared_in_ward": "तुमच्या प्रभागात",
  "compared_citywide": "शहरभर",
  "pending_applications": "प्रलंबित अर्ज",
  "view_application": "अर्ज पहा",
  "bill_details": "बिलाचा तपशील",
  "tax_head": "कर शीर्ष",
  "taxable_base": "करपात्र आधार",
  "rate": "दर %",
  "tax_amount": "कर रक्कम",
  "rebate": "सवलत / सूट",
  "penalty": "दंड",
  "line_total": "एकूण",
  "total_tax": "एकूण कर",
  "total_rebate": "एकूण सवलत",
  "arrears": "थकबाकी (उशिरा भरणा)",
  "months_overdue": "महिने थकीत",
  "net_amount": "निव्वळ बिल रक्कम",
  "total_payable": "एकूण देय रक्कम",
  "back": "मागे",
  "checkout_title": "पेमेंट चेकआउट",
  "checkout_all_title": "थकबाकी बिले भरा",
  "select_bills_hint": "या पेमेंटमध्ये कोणती बिले समाविष्ट करायची ते निवडा.",
  "selected_total": "निवडलेली एकूण रक्कम",
  "select_at_least_one": "पुढे जाण्यासाठी किमान एक बिल निवडा.",
  "bills_in_payment": "या पेमेंटमधील बिले",
  "bill_in_payment": "या पेमेंटमधील बिल",
  "pay_amount": "भरावयाची रक्कम",
  "full_amount": "संपूर्ण थकबाकी भरा",
  "partial_note": "तुम्ही आंशिक रक्कम भरू शकता; संपूर्ण रक्कम भरेपर्यंत बिल आंशिक (PARTIAL) स्थितीत राहील.",
  "partial_note_multi": "तुम्ही आंशिक रक्कम भरू शकता; ती आधी तुमच्या सर्वात जुन्या थकबाकी बिलांना लागू केली जाईल.",
  "proceed_pay": "पेमेंटकडे जा",
  "settling_payment": "पेमेंट पूर्ण करत आहे…",
  "all_payments_success": "निवडलेली सर्व बिले यशस्वीरित्या भरली गेली आहेत.",
  "some_payments_failed": "काही पेमेंट पूर्ण होऊ शकले नाहीत — खाली तपशील पहा.",
  "gateway_title": "PMC सुरक्षित पेमेंट गेटवे",
  "gateway_note": "हे प्रात्यक्षिकासाठी सिम्युलेटेड पेमेंट गेटवे आहे. कोणतेही खरे पैसे आकारले जात नाहीत.",
  "upi": "UPI",
  "card": "कार्ड",
  "netbanking": "नेट बँकिंग",
  "upi_id": "UPI आयडी",
  "card_no": "कार्ड क्रमांक",
  "card_name": "कार्डवरील नाव",
  "expiry": "वैधता (MM/YY)",
  "cvv": "CVV",
  "select_bank": "बँक निवडा",
  "pay_btn": "भरा",
  "simulate_fail": "अपयश सिम्युलेट करा",
  "cancel": "रद्द करा",
  "pay_success": "पेमेंट यशस्वी!",
  "pay_success_d": "तुमचे पेमेंट नोंदवले गेले आहे आणि पावती तयार झाली आहे.",
  "pay_failed": "पेमेंट अयशस्वी",
  "pay_failed_d": "तुमचे पेमेंट प्रक्रिया होऊ शकले नाही. तुमच्या बिलावर कोणतीही रक्कम नोंदवली गेली नाही. कृपया पुन्हा प्रयत्न करा.",
  "receipt_no": "पावती क्रमांक",
  "payment_no": "पेमेंट क्रमांक",
  "txn_no": "व्यवहार क्रमांक",
  "view_receipt": "पावती पहा",
  "try_again": "पुन्हा प्रयत्न करा",
  "receipt_title": "पेमेंट पावती",
  "receipt_date": "पावती दिनांक",
  "payment_mode": "पेमेंट पद्धत",
  "amount_paid": "भरलेली रक्कम",
  "print_receipt": "पावती छापा",
  "receipt_footer": "ही संगणकाद्वारे तयार केलेली पावती आहे आणि तिला स्वाक्षरीची आवश्यकता नाही.",
  "history_title": "पेमेंट इतिहास",
  "payment_date": "पेमेंट दिनांक",
  "reference": "संदर्भ",
  "receipt": "पावती",
  "no_payments": "या मालमत्तेसाठी अद्याप कोणतेही पेमेंट आढळले नाही.",
  "signin_title": "नागरिक साइन इन",
  "signup_title": "नागरिक नोंदणी",
  "full_name": "पूर्ण नाव",
  "mobile": "मोबाइल क्रमांक",
  "email": "ईमेल (ऐच्छिक)",
  "signin_btn": "साइन इन",
  "signup_btn": "नोंदणी करा",
  "signin_help": "तुमचा नोंदणीकृत मोबाइल क्रमांक आणि तुमच्या जोडलेल्या मालमत्ता क्रमांकांपैकी कोणताही एक वापरून साइन इन करा.",
  "signup_help": "तुमचे नाव आणि मोबाइल क्रमांकासह नोंदणी करा, नंतर PID वापरून तुमची मालमत्ता जोडा.",
  "no_account": "खाते नाही?",
  "have_account": "आधीच नोंदणी केली आहे?",
  "signin_failed": "साइन इन अयशस्वी. तुमचा मोबाइल क्रमांक आणि जोडलेला मालमत्ता क्रमांक तपासा.",
  "mobile_exists": "हा मोबाइल क्रमांक आधीच नोंदणीकृत आहे. कृपया साइन इन करा.",
  "signup_ok": "नोंदणी यशस्वी! आता खाली तुमची मालमत्ता जोडा.",
  "link_property": "मालमत्ता जोडा",
  "link_btn": "मालमत्ता जोडा",
  "link_help": "तुमच्या बिलावर छापल्याप्रमाणे तुमचा मालमत्ता क्रमांक (PID) प्रविष्ट करा. मालमत्तेच्या नोंदीवरील मोबाइल क्रमांक तुमच्या नोंदणीकृत मोबाइलशी जुळल्यास, ती आपोआप सत्यापित होते.",
  "linked_ok": "मालमत्ता तुमच्या खात्याशी जोडली गेली.",
  "link_exists": "ही मालमत्ता आधीच तुमच्या खात्याशी जोडलेली आहे.",
  "pid_not_found": "या PID सह कोणतीही मालमत्ता आढळली नाही.",
  "my_properties": "माझ्या मालमत्ता",
  "no_linked": "अद्याप कोणतीही मालमत्ता जोडलेली नाही. PID वापरून तुमची पहिली मालमत्ता जोडा.",
  "verified": "सत्यापित",
  "unverified": "असत्यापित",
  "welcome": "स्वागत",
  "calc_title": "मालमत्ता कर कॅल्क्युलेटर",
  "calc_note": "हा कॅल्क्युलेटर केवळ अंदाजे आकडा देतो. तुमचा प्रत्यक्ष कर PMC मूल्यांकनाद्वारे ठरवला जातो आणि तुमच्या अधिकृत बिलावर दिसतो.",
  "disclaimer_label": "अस्वीकरण",
  "usage_type": "वापराचा प्रकार",
  "construction_type": "बांधकाम प्रकार",
  "residential": "निवासी",
  "non_residential": "अनिवासी / व्यावसायिक",
  "open_plot": "मोकळा भूखंड",
  "area_sqft": "बांधकाम क्षेत्र (चौ.फूट)",
  "rate_sqft": "दर प्रति चौ.फूट प्रति महिना (₹)",
  "calc_btn": "गणना करा",
  "est_arv": "अंदाजे वार्षिक करपात्र मूल्य",
  "est_tax": "अंदाजे वार्षिक कर",
  "early_note": "मासिक थकबाकी टाळण्यासाठी देय तारखेपूर्वी पैसे भरा. सवलत कालावधीत लवकर पेमेंट केल्यास PMC नियमांनुसार ५–१०% सूट मिळू शकते.",
  "contact_title": "संपर्क करा",
  "subject": "विषय",
  "message": "संदेश",
  "send_btn": "तक्रार नोंदवा",
  "fetch_details_btn": "तपशील मिळवा",
  "fetching_btn": "मिळवत आहे…",
  "pid_verified": "सत्यापित",
  "pid_fetch_not_found": "या नेमक्या आयडीसह मालमत्ता आढळली नाही. कृपया टायपिंग तपासा आणि पुन्हा प्रयत्न करा.",
  "pid_verify_hint": "हे भरण्यासाठी वरील प्रॉपर्टी आयडी सत्यापित करा",
  "contact_ok": "तुमची तक्रार नोंदवली गेली आहे. आमची टीम लवकरच तुमच्याशी संपर्क साधेल.",
  "helpline": "हेल्पलाइन",
  "email_us": "ईमेल",
  "office": "मुख्य कार्यालय",
  "office_addr": "PMC इमारत, शिवाजीनगर, पुणे - ४११००५, महाराष्ट्र",
  "about_title": "पोर्टलबद्दल",
  "faqs_title": "वारंवार विचारले जाणारे प्रश्न",
  "dash_sub": "तुमचा मालमत्ता कर आणि सेवा सहज व्यवस्थापित करा",
  "total_tax_amount": "एकूण देय कर रक्कम",
  "total_paid": "एकूण भरलेले",
  "total_properties": "एकूण मालमत्ता",
  "tab_overview": "आढावा",
  "tab_properties": "मालमत्ता",
  "tab_schemes": "योजना",
  "tab_services": "सेवा",
  "urgent_action": "तातडीची कारवाई आवश्यक",
  "due": "देय",
  "outstanding_amt": "थकबाकी रक्कम",
  "no_urgent": "छान! तुमच्या कोणत्याही जोडलेल्या मालमत्तेवर थकबाकी नाही.",
  "recent_activity": "अलीकडील घडामोडी",
  "last_login": "शेवटचे लॉगिन",
  "view_more": "अधिक पहा",
  "view_less": "कमी पहा",
  "no_activity": "अद्याप कोणतीही घडामोड नाही. पोर्टलवरील तुमच्या कृती येथे दिसतील.",
  "notifications": "सूचना",
  "no_notifications": "कोणत्याही नवीन सूचना नाहीत.",
  "nav_notifications": "सूचना",
  "notifications_title": "सूचना",
  "view_all_notifications": "सर्व सूचना पहा",
  "mark_all_read": "सर्व वाचल्या म्हणून चिन्हांकित करा",
  "filter_all": "सर्व",
  "filter_unread": "न वाचलेल्या",
  "no_notifications_page": "तुमच्याकडे अद्याप कोणत्याही सूचना नाहीत.",
  "notif_payment_paid": "पेमेंट प्राप्त झाले",
  "notif_payment_partial": "अंशतः पेमेंट नोंदवले गेले",
  "notif_app_accepted": "अर्ज पुनरावलोकनासाठी स्वीकारला",
  "notif_app_assigned": "अर्ज क्षेत्रीय निरीक्षकाकडे नियुक्त करण्यात आला",
  "notif_app_rejected": "अर्ज नाकारला",
  "notif_app_closed": "अर्ज बंद करण्यात आला",
  "notif_query_resolved": "तुमची तक्रार निकाली काढण्यात आली आहे",
  "notif_bill_overdue": "देय रक्कम थकीत आहे",
  "notif_col_notification": "सूचना",
  "notif_col_when": "वेळ",
  "schemes_empty": "PMC ने जाहीर केलेल्या सवलत व अभय योजना येथे दिसतील. सध्या कोणतीही योजना खुली नाही.",
  "services_empty": "आणखी नागरिक सेवा लवकरच येत आहेत.",
  "svc_calculator": "कर कॅल्क्युलेटर",
  "svc_calculator_d": "तुमच्या वार्षिक मालमत्ता कराचा अंदाज घ्या.",
  "svc_history": "पेमेंट इतिहास",
  "svc_history_d": "मागील पेमेंट पहा आणि पावत्या डाउनलोड करा.",
  "svc_query": "तक्रार नोंदवा",
  "svc_query_d": "मालमत्ता कर विभागाशी संपर्क साधा.",
  "svc_faq": "प्रश्नोत्तरे",
  "svc_faq_d": "सामान्य प्रश्नांची उत्तरे.",
  "nav_property": "मालमत्ता",
  "nav_paytax": "कर भरा",
  "nav_taxdetails": "कर तपशील",
  "nav_services": "सेवा",
  "nav_faq": "प्रश्नोत्तरे",
  "link_this": "ही मालमत्ता माझ्या खात्याशी जोडा",
  "not_linked_note": "ही मालमत्ता अद्याप तुमच्या खात्याशी जोडलेली नाही.",
  "act_linked": "मालमत्ता यशस्वीरित्या जोडली",
  "act_pay_ok": "मालमत्ता कर भरणा प्राप्त झाला",
  "act_pay_fail": "मालमत्ता कर भरणा अयशस्वी",
  "act_registered": "खाते यशस्वीरित्या तयार झाले",
  "act_bill": "मालमत्ता कर बिल तयार झाले",
  "change_property": "मालमत्ता बदला",
  "bd_doc_title": "मालमत्ता कर बिल",
  "bd_doc_title_cda": "मालमत्ता कर — दाखला बदल फरक बिल",
  "bd_property_details": "मालमत्तेचा तपशील",
  "bd_owner_details": "मालकाचा तपशील",
  "bd_arv": "वार्षिक करपात्र रक्कम",
  "bd_arv_cda": "वार्षिक करपात्र मूल्य — दाखला बदल",
  "bd_arv_uc": "वार्षिक करपात्र मूल्य — अनधिकृत बांधकाम",
  "bd_tax_bill": "मालमत्ता कर बिल",
  "bd_pid": "मालमत्ता क्रमांक",
  "bd_fin_year": "आर्थिक वर्ष",
  "bd_meter_no": "बिगर-निवासी मीटर क्र.",
  "bd_assess_date": "आकारणी दिनांक",
  "bd_last_payment": "शेवटचा भरणा",
  "bd_print_date": "बिल छपाई दिनांक",
  "bd_name": "नाव",
  "bd_addr": "पत्ता",
  "bd_prop_desc": "मालमत्तेचे वर्णन",
  "bd_resident": "निवासी",
  "bd_non_resident": "बिगर-निवासी",
  "bd_gen_exmp": "सर्वसाधारण सूट",
  "bd_total": "एकूण",
  "bd_total_arv": "एकूण ARV",
  "bd_arv_component": "ARV घटक",
  "bd_prev_arv": "पूर्वीचे ARV",
  "bd_new_arv": "नवीन ARV",
  "bd_old_arv": "जुने ARV",
  "bd_old_x": "जुना वार्षिक कर (×1)",
  "bd_new_x": "कर ×",
  "bd_uc_reference_suffix": " (संदर्भ)",
  "bd_change": "अधिभार (बिल केलेला)",
  "bd_uc_arv_note_prefix": "या योजनेसाठी ARV सुधारित केले जात नाही. दंड (×",
  "bd_uc_arv_note_suffix": ") जुन्या मूल्यांकनाच्या करावर आकारला जातो — खालील कर बिल पहा.",
  "bd_uc_surcharge_formula_note": "हे अनधिकृत बांधकाम दंड बिल नियमित वार्षिक बिलापेक्षा स्वतंत्रपणे — आणि त्याव्यतिरिक्त — आकारले जाते, जे आधीच जुना कर ×1 दराने वसूल करते. त्यामुळे येथे फक्त अधिभार आकारला जातो.",
  "bd_kalavidhi": "कालावधी",
  "bd_days": "दिवस",
  "bd_to": "ते",
  "bd_tax_pct": "कर %",
  "bd_apr_sep": "एप्रिल–सप्टेंबर",
  "bd_oct_mar": "ऑक्टोबर–मार्च",
  "bd_fixed": "निश्चित",
  "bd_year_tax": "वार्षिक कर रक्कम",
  "bd_diff_amount": "फरक रक्कम",
  "bd_annual_tax_amount": "वार्षिक कर रक्कम",
  "bd_billing_period": "कालावधीनुसार कर मागणी",
  "bd_prorated_note_title": "कालावधीनुसार बिल दि.",
  "bd_prorated_note_body": "ही मालमत्ता वर्षाच्या मधे नोंदणीकृत झाली आहे. कर मागणी सक्रिय कालावधीनुसार आकारली आहे",
  "bd_prorated_note_days_prefix": "एकूण",
  "bd_prorated_note_days_of": "दिवसांपैकी",
  "bd_prorated_note_days_suffix": "दिवस ({period})",
  "bd_prorated_note_years_suffix": "वर्षे गुणक",
  "bd_prorated_note_tail": " नोंदणीच्या दिनांकावरून आकारले आहे.",
  "bd_self_occupied_arv_conc": "स्वयं-व्याप्त ARV सवलत",
  "bd_difference": "फरक",
  "bd_no_tax_lines": "कराच्या नोंदी आढळल्या नाहीत",
  "bd_normal_demand": "सर्वसाधारण कर मागणी",
  "bd_uc_tax_demand": "अनधिकृत बांधकाम कर मागणी",
  "bd_ff_exmp": "अग्निशमन कर्मचारी सूट (ऐच्छिक कर शून्य केले)",
  "bd_sra_conc": "SRA झोपडपट्टी योजना सवलत",
  "bd_village_conc": "गाव टप्पा सवलत",
  "bd_year": "वर्ष",
  "bd_of5": "/ ५",
  "bd_entry": "समावेश दिनांक",
  "bd_net_after_conc": "निव्वळ कर मागणी (सवलतीनंतर)",
  "bd_dakhala_mult": "दाखला गुणक",
  "bd_normal_rate": "सर्वसाधारण दर",
  "bd_adj_demand": "समायोजित चालू मागणी",
  "bd_solar_disc": "सौर/गांडूळखत/पर्जन्य जलसंधारण सूट",
  "bd_prior_arrears": "मागील कालावधीची थकबाकी",
  "bd_carried_fwd_from": "पुढे आणलेली थकबाकी — बिल",
  "bd_cf_mismatch_warning": "ही पुढे आणलेली रक्कम खालील निव्वळ बिल रकमेत समाविष्ट नाही. देय एकूण रक्कम निश्चित करण्यासाठी कृपया मालमत्ता कर कार्यालयाशी संपर्क साधा.",
  "bd_superseded_warning": "हे बिल रद्द करून {bill} ने बदलण्यात आले आहे. येथे दर्शवलेली आकडेवारी मूळ, चुकीच्या गणनेवर आधारित आहे आणि ती देय नाही.",
  "bd_gp_arrear": "ग्रामपंचायत कर थकबाकी (गाव आधार — निश्चित, १००%)",
  "bd_overdue_penalty": "विलंब दंड",
  "bd_excess": "जादा रक्कम",
  "bd_early_disc": "लवकर भरण्याची सूट",
  "bd_net_bill": "निव्वळ बिल रक्कम",
  "bd_net_bill_current": "निव्वळ बिल रक्कम (चालू वर्ष)",
  "bd_register_snapshot_as_at": "नोंदवही स्थिती दिनांक",
  "bd_total_as_per_register": "नोंदवहीनुसार एकूण",
  "bd_payable_today_current_only": "फक्त चालू वर्ष — मागील कालावधीची थकबाकी वगळून",
  "bd_ledger_settled": "भरणा पूर्ण",
  "bd_ledger_settled_note": "पुणे मनपाच्या मालमत्ता कर नोंदींनुसार हे बिल पूर्ण भरले गेले आहे — कोणतीही रक्कम थकीत नाही, त्यामुळे या पोर्टलवरून पुन्हा भरणा करता येणार नाही. ही माहिती चुकीची वाटत असल्यास कृपया मालमत्ता कर कार्यालयाशी संपर्क साधा.",
  "bd_in_credit": "जमा रक्कम",
  "bd_credit_note": "या बिलावर जमा शिल्लक आहे: या मालमत्तेवर आधीच भरलेली जादा रक्कम या वर्षाच्या मागणीपेक्षा जास्त आहे, त्यामुळे कोणतीही रक्कम देय नाही. जमा शिल्लकबाबत कृपया मालमत्ता कर कार्यालयाशी संपर्क साधा.",
  "bd_live_ledger": "चालू खातेवही शिल्लक",
  "bd_ledger_arrears": "थकबाकी (मागील वर्षे)",
  "bd_ledger_current": "चालू वर्षाची उर्वरित रक्कम",
  "bd_ledger_current_hint": "कर, दंड वगळून",
  "bd_ledger_total": "शेवटच्या अद्ययावतीकरणानुसार एकूण देय",
  "bd_ledger_of_tax": "त्यापैकी मालमत्ता कर",
  "bd_ledger_of_penalty": "त्यापैकी जमा झालेला दंड",
  "bd_ledger_penalty_pct": "एकूण देय रकमेच्या",
  "bd_ledger_diff": "वरील नोंदवही स्थितीच्या तुलनेत फरक",
  "bd_ledger_diff_hint": "बिल छापल्यानंतर खातेवहीत बदल झाला आहे",
  "bd_ledger_asat": "खातेवही आकडेवारी दिनांक",
  "bd_ledger_note": "केवळ माहितीसाठी — ही या पोर्टलवरून देय असलेली रक्कम नाही; पोर्टलवरून वरील चालू वर्षाचे बिल भरता येते. ही आकडेवारी आपल्या मालमत्ता कर खात्याची कालनिहाय स्थिती असून, दर्शवलेल्या वेळेनंतर केलेले भरणे यात समाविष्ट नाही. थकबाकी भरण्यापूर्वी कृपया मालमत्ता कर कार्यालयाकडून नेमकी देय रक्कम निश्चित करा.",
  "bd_ledger_stale": "ही स्थिती दोन दिवसांपेक्षा जुनी आहे.",
  "bd_in_words": "अक्षरी",
  "bd_total_arrears": "एकूण थकबाकी",
  "bd_payable_today": "आज देय एकूण रक्कम",
  "bd_penalty_note": "दंड फरक आकारणी (वार्षिक)",
  "bd_owner_sign": "मालमत्ता धारकाची सही",
  "bd_auth_sign": "अधिकृत स्वाक्षरीकर्ता — पुणे मनपा",
  "bd_computer_note": "हे संगणकीकृत बिल आहे. ऑनलाइन भरण्यासाठी सहीची आवश्यकता नाही.",
  "bd_print": "बिल छापा",
  "bd_overdue_title": "बिल थकीत आहे",
  "bd_overdue_msg": "देय दिनांकानंतर %d महिने — %s थकबाकी निर्धारित कर-शीर्षांवर लागू झाली आहे. आज देय एकूण: %s.",
  "bd_village_banner_t": "गाव हद्दीतील मालमत्ता",
  "bd_village_phase": "टप्पा गुणांक: फरक + ग्रामपंचायत आधाराच्या %s%%. पुणे मनपा समावेश: %s. पाणी कर: पुणे मनपा दराच्या सरसकट २०%%. EDU, NEDU, EGAR, LP कर १००%%.",
  "bd_village_full": "पूर्ण पुणे मनपा कर लागू (वर्ष ५+ किंवा २०२२ पूर्वीचे गाव). पाणी कर: पुणे मनपा दराच्या सरसकट २०%.",
  "svc_pt1": "Pt1 - नवीन कर आकारणी सेवा",
  "svc_pt1_d": "नवीन मालमत्तेच्या प्रथम कर आकारणीसाठी अर्ज करा.",
  "svc_pt1_track": "माझे अर्ज",
  "svc_pt1_track_d": "तुमच्या सेवा अर्जांची स्थिती पहा.",
  "pt1_title": "Pt1 - नवीन कर आकारणी सेवा",
  "pt1_short": "PT1 अर्ज शुल्क",
  "pt1_sub": "नव्याने बांधलेल्या / अद्याप कर आकारणी न झालेल्या मालमत्तेच्या प्रथम कर आकारणीसाठी अर्ज",
  "pt1_intro": "नव्याने बांधलेली किंवा अद्याप कर आकारणी न झालेली मालमत्ता मालमत्ता करासाठी नोंदवण्यासाठी ही सेवा वापरा. अर्ज सादर केल्यानंतर PMC मालमत्तेची पाहणी व आकारणी करून नवीन मालमत्ता क्रमांक (PID) देईल.",
  "pt1_step1": "अर्जाचा तपशील",
  "pt1_step2": "कागदपत्रे अपलोड करा",
  "pt1_step3": "तपासा व शुल्क भरा",
  "pt1_step4": "पोचपावती",
  "pt1_sec_location": "मालमत्तेचे स्थान",
  "pt1_sec_applicant": "अर्जदाराचा तपशील",
  "pt1_sec_property": "नवीन मालमत्तेचा पत्ता",
  "svc_sec_details": "अतिरिक्त तपशील",
  "pt1_sec_construction": "बांधकामाचा तपशील",
  "pt1_sec_documents": "कागदपत्रे",
  "pt1_addr1": "पत्ता ओळ १",
  "pt1_addr2": "पत्ता ओळ २",
  "pt1_locality": "परिसर / भाग",
  "pt1_city": "शहर",
  "pt1_pin": "पिन कोड",
  "pt1_mixed": "मिश्र वापर",
  "pt1_construction_type": "बांधकामाचा प्रकार",
  "pt1_ct_rcc": "आरसीसी",
  "pt1_ct_lb": "लोड बेअरिंग / विटांचे",
  "pt1_ct_patra": "पत्रा शेड / तात्पुरते",
  "pt1_ct_open": "मोकळी जमीन",
  "pt1_floors": "एकूण मजले",
  "pt1_construction_end": "बांधकाम पूर्ण झाल्याची तारीख",
  "pt1_select": "-- निवडा --",
  "pt1_save_proceed": "जतन करा व पुढे जा",
  "pt1_upload_note": "आवश्यक (*) कागदपत्रे jpg, jpeg, png किंवा pdf स्वरूपात अपलोड करा (कमाल १० MB). कागदपत्रे स्व-साक्षांकित असावीत.",
  "pt1_doc_8a": "८अ / ७/१२ उतारा",
  "pt1_doc_sale": "खरेदीखत / नोंदणीकृत करारनामा",
  "pt1_doc_index2": "सूची II (इंडेक्स II)",
  "pt1_doc_nodues": "मालमत्ता कर थकबाकी नसल्याचा दाखला",
  "pt1_doc_map": "मालमत्तेचा नकाशा",
  "pt1_doc_occ": "भोगवटा प्रमाणपत्र",
  "pt1_choose_file": "फाईल निवडा",
  "pt1_no_file": "फाईल निवडलेली नाही...",
  "pt1_uploaded": "अपलोड झाले",
  "pt1_not_uploaded": "अपलोड केलेले नाही",
  "pt1_up_err_size": "फाईल १० MB मर्यादेपेक्षा मोठी आहे.",
  "pt1_up_err_type": "फक्त jpg, jpeg, png किंवा pdf फाईल चालतील.",
  "pt1_up_err_generic": "अपलोड अयशस्वी. कृपया पुन्हा प्रयत्न करा.",
  "pt1_up_err_required": "हे कागदपत्र आवश्यक आहे.",
  "pt1_source_pid": "ज्या PID द्वारे अर्ज केला",
  "pt1_edit_details": "तपशील बदला",
  "pt1_edit_docs": "कागदपत्रे बदला",
  "pt1_fee_title": "एकूण शुल्क",
  "pt1_fee_note": "हा अर्ज सादर करण्यासाठी एक-वेळचे, परत न मिळणारे अर्ज प्रक्रिया शुल्क ऑनलाइन भरावे लागते.",
  "pt1_confirm_pay": "निश्चित करा व भरा",
  "pt1_app_no": "अर्ज क्रमांक",
  "pt1_ack_title": "अर्जाची पोचपावती",
  "pt1_applied_on": "अर्जाची तारीख",
  "pt1_submitted_on": "सादर केल्याची तारीख",
  "pt1_submitted_t": "अर्ज यशस्वीरीत्या सादर झाला!",
  "pt1_submitted_d": "तुमचे शुल्क मिळाले असून तुमचा अर्ज आकारणीसाठी PMC कडे पाठवण्यात आला आहे.",
  "pt1_incomplete_note": "हा अर्ज अद्याप सादर झालेला नाही. उर्वरित पायऱ्या पूर्ण करून अर्ज सादर करा.",
  "pt1_next_note": "पुढे काय: PMC चे मूल्यांकन अधिकारी तुमची कागदपत्रे तपासून मालमत्तेची पाहणी करतील. आकारणीनंतर नवीन मालमत्ता क्रमांक (PID) दिला जाईल आणि तुमचे पहिले मालमत्ता कर बिल तयार होईल. संदर्भासाठी अर्ज क्रमांक जपून ठेवा.",
  "pt1_print_ack": "पोचपावती छापा",
  "pt1_resume": "पुढे सुरू ठेवा",
  "pt1_track_title": "माझे अर्ज",
  "pt1_track_sub": "अर्जाची स्थिती व पोचपावती पाहण्यासाठी तुमचा अर्ज क्रमांक भरा",
  "pt1_docs_count": "अपलोड केलेली कागदपत्रे",
  "pt1_err_mobile": "वैध १० अंकी मोबाईल क्रमांक भरा.",
  "pt1_err_email": "वैध ईमेल पत्ता भरा.",
  "pt1_err_pin": "वैध ६ अंकी पिन कोड भरा.",
  "pt1_err_area": "बांधीव क्षेत्र चौ.फूट मध्ये भरा.",
  "pt1_err_date": "वैध मागील तारीख भरा.",
  "pt1_public_cta_t": "नवीन मालमत्तेची अद्याप कर आकारणी झालेली नाही?",
  "pt1_public_cta_apply": "अर्ज करा: Pt1 - नवीन कर आकारणी सेवा",
  "pt1_public_cta_track": "अर्जाची स्थिती पहा",
  "pt1_find_title": "अर्ज शोधा",
  "pt1_not_found": "या अर्ज क्रमांकाचा कोणताही अर्ज सापडला नाही.",
  "pt1_keep_no": "तुमचा अर्ज क्रमांक नोंदवून ठेवा — मुख्य पृष्ठावरील \"अर्जाची स्थिती पहा\" मध्ये तो भरून तुम्ही कधीही हा अर्ज पुन्हा उघडू शकता.",
  "svc_pt2": "Pt2 - फेर कर आकारणी सेवा",
  "svc_pt2_d": "वाढीव बांधकाम किंवा वापर बदलानंतर मालमत्तेच्या फेर आकारणीसाठी अर्ज करा.",
  "pt2_title": "Pt2 - फेर कर आकारणी सेवा",
  "pt2_short": "PT2 अर्ज शुल्क",
  "pt2_sub": "आकारणी झालेल्या मालमत्तेत बदल झाल्यानंतर फेर कर आकारणीसाठी अर्ज",
  "pt2_intro": "तुमच्या आकारणी झालेल्या मालमत्तेत बदल झाला असल्यास — उदा. वाढीव बांधकाम / विस्तार किंवा वापरात बदल (निवासी ↔ अनिवासी) — ही सेवा वापरा. PMC मालमत्तेची पुनर्तपासणी करून त्याच PID अंतर्गत कर आकारणी सुधारित करेल.",
  "pt2_sec_property": "आकारणी झालेली मालमत्ता",
  "pt2_sec_change": "बदलाचा तपशील",
  "pt2_reason": "फेर आकारणीचे कारण",
  "pt2_reason_ext": "वाढीव बांधकाम / विस्तार",
  "pt2_reason_use": "वापरात बदल",
  "pt2_prev_usage": "सध्याचा वापर",
  "pt2_new_usage": "बदलानंतरचा वापर",
  "pt2_addl_area": "वाढीव क्षेत्र (चौ.फूट)",
  "pt2_total_area": "बदलानंतर एकूण क्षेत्र (चौ.फूट)",
  "pt2_change_date": "बदल पूर्ण झाल्याची तारीख",
  "pt2_change_desc": "बदलाचे वर्णन",
  "pt2_doc_permit": "मंजूर बांधकाम नकाशा / परवानगी",
  "pt2_err_reason": "फेर आकारणीचे कारण निवडा.",
  "pt2_err_addl_area": "वाढीव बांधकाम क्षेत्र चौ.फूट मध्ये भरा.",
  "pt2_err_usage_same": "बदलानंतरचा वापर सध्याच्या वापरापेक्षा वेगळा असावा.",
  "pt2_submitted_d": "तुमचे शुल्क भरणा प्राप्त झाले असून तुमचा फेर आकारणी अर्ज PMC कडे पाठवण्यात आला आहे.",
  "pt2_next_note": "पुढे काय: PMC मूल्यांकनकर्ता तुमची कागदपत्रे तपासून मालमत्तेची पुनर्तपासणी करतील. सुधारित आकारणी त्याच PID अंतर्गत तुमच्या पुढील मालमत्ता कर बिलांमध्ये दिसेल. संदर्भासाठी अर्ज क्रमांक जपून ठेवा.",
  "svc_leave_title": "हा अर्ज सोडून जायचे?",
  "svc_leave_msg": "तुमचा अर्ज अद्याप सादर झालेला नाही. आता बाहेर पडल्यास भरलेली सर्व माहिती आणि अपलोड केलेली कागदपत्रे रद्द होतील.",
  "svc_leave_stay": "अर्ज सुरू ठेवा",
  "svc_leave_discard": "रद्द करून बाहेर पडा",
  "svc_draft_note": "टीप: अर्ज शुल्क भरेपर्यंत तुमचा अर्ज जतन होत नाही. भरणा पूर्ण होण्यापूर्वी तुम्ही ही सेवा सोडल्यास किंवा ब्राउझर बंद केल्यास, भरलेली सर्व माहिती आणि अपलोड केलेली कागदपत्रे रद्द होतील.",
  "svc_myapps_title": "या मालमत्तेचे अर्ज",
  "svc_myapps_none": "या मालमत्तेसाठी अद्याप कोणतेही अर्ज सादर झालेले नाहीत.",
  "svc_service": "सेवा",
  "svc_view": "पहा",
  "svc_required_title": "आवश्यक क्षेत्रे रिकामी आहेत",
  "svc_required_msg": "पुढे जाण्यापूर्वी कृपया खालील आवश्यक क्षेत्रे भरा:",
  "svc_required_ok": "ठीक आहे, भरतो",
  "required": "हे क्षेत्र आवश्यक आहे.",
  "error_generic": "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.",
  "footer_rights": "पुणे महानगरपालिका. सर्व हक्क राखीव.",
  "quick_links": "द्रुत दुवे",
  "get_in_touch": "संपर्कात रहा",
  // ── Added for the React portal (no PHP equivalent) ──
  "apply_now": "आता अर्ज करा",
  "next": "पुढे",
  "print": "छापा",
  "upload": "अपलोड करा",
  "replace": "बदला",
  "remove": "काढून टाका",
  "required_short": "आवश्यक",
  "built_area": "बांधकाम क्षेत्र (चौ.फूट)",
  "built_year": "बांधकाम वर्ष",
  "total_billed": "एकूण बिल रक्कम",
  "est_half": "अंदाजे सहामाही कर",
  "calc_sub": "तुमच्या वार्षिक मालमत्ता कराचा अंदाजे अंदाज मिळवा.",
  "calc_ward": "प्रभाग",
  "calc_peth": "पेठ",
  "calc_select_ward": "प्रभाग निवडा",
  "calc_select_peth": "पेठ निवडा",
  "faq_sub": "नागरिक सर्वाधिक विचारत असलेल्या प्रश्नांची उत्तरे.",
  "contact_sub": "तक्रार नोंदवा, आमची टीम लवकरच प्रतिसाद देईल.",
  "svc_intro": "मालमत्ता कर सेवांसाठी ऑनलाइन अर्ज करा.",
  "svc_needs_pid": "प्रथम तुमचा मालमत्ता क्रमांक शोधा.",
  "bill_footer": "हे संगणकाद्वारे तयार केलेले बिल आहे आणि त्यावर स्वाक्षरीची आवश्यकता नाही.",
  "age_not_overdue": "थकबाकी नाही",
  "age_1_3": "१-३ महिने",
  "age_4_6": "४-६ महिने",
  "age_7_12": "७-१२ महिने",
  "age_12_plus": "१२+ महिने",
  "update_contact_details": "संपर्क तपशील अद्यतनित करा",
  "update_contact_details_desc": "या मालमत्तेसाठी नोंदणीकृत मोबाईल क्रमांक आणि ईमेल अद्यतनित करा.",
  "save": "जतन करा",
  "captcha_title": "सुरक्षा तपासणी",
  "captcha_prompt": "तुम्ही रोबोट नाही याची खात्री करण्यासाठी हे सोडवा",
  "captcha_answer": "तुमचे उत्तर",
  "captcha_refresh": "नवीन प्रश्न मिळवा",
  "captcha_incorrect": "चुकीचे उत्तर. कृपया पुन्हा प्रयत्न करा.",
  "captcha_required": "पुढे जाण्यासाठी सुरक्षा प्रश्नाचे उत्तर द्या.",
  "invalid_mobile": "वैध १०-अंकी मोबाईल क्रमांक टाका.",
  "invalid_email": "वैध ईमेल पत्ता टाका.",
  "contact_updated": "संपर्क तपशील यशस्वीरित्या अद्यतनित झाला.",
  "topbar_brand": "PMC - नागरिक पोर्टल",
  "nav_myqueries": "माझ्या तक्रारी",
  "myqueries_title": "माझ्या तक्रारी",
  "myqueries_sub": "आपण या मालमत्तेसाठी 'संपर्क साधा' द्वारे नोंदवलेल्या तक्रारी.",
  "myqueries_none": "आपण या मालमत्तेसाठी अद्याप कोणतीही तक्रार नोंदवलेली नाही.",
  "myqueries_received": "नोंदवली",
  "myqueries_answer": "उत्तर",
  "myqueries_pending": "मालमत्ता कर विभागाकडून उत्तराची प्रतीक्षा आहे.",
  "myqueries_no_remarks": "निकाली काढले, अतिरिक्त शेरा नाही.",
  "myqueries_resolved_on": "निकाली काढल्याची तारीख",
  "myqueries_new": "नवीन तक्रार नोंदवा",
  "myqueries_dept_response": "मालमत्ता कर विभागाकडून प्रतिसाद",
  "svc_already_open": "विनंती आधीच सुरू आहे",
  "svc_already_open_note": "या मालमत्तेसाठी या सेवेची विनंती आधीपासून सुरू आहे.",
  "svc_view_my_applications": "माझे अर्ज पहा",
  "svc_pt5_outstanding_title": "प्रथम थकीत रक्कम भरा",
  "svc_pt5_outstanding_msg": "तुमची {amount} एकूण थकीत रक्कम (Total Outstanding) प्रलंबित आहे. कृपया {service} अर्ज भरण्यापूर्वी प्रलंबित थकीत रक्कम भरा.",
  "svc_pay_outstanding_btn": "थकीत रक्कम भरा",
  "svc_pt5_transfer_fee": "हक्क बदल शुल्क",
  "svc_pt5_cfc_charges": "अर्ज शुल्क",
  "svc_pt5_base_fee": "मूल शुल्क",
  "svc_pt5_excess_rv": "अतिरिक्त करपात्र मूल्य (RV)",
  "svc_pt5_slabs": "स्लॅब",
  "svc_pt5_exempt": "सवलत प्राप्त",
  "myqueries_new_desc": "तुमची तक्रार मालमत्ता कर विभागाकडे पाठवली जाईल आणि सादर केल्यानंतर या यादीत दिसेल.",
  "close": "बंद करा",
  "svc_rejected_t": "अर्ज नाकारला",
  "svc_rejected_d": "तुमचा अर्ज मंजूर होऊ शकला नाही. खालील कारण पहा.",
  "svc_reject_reason": "कारण",
  "svc_reject_remarks": "शेरा",
  "footer_system_name": "पीएमसी मालमत्ता कर प्रणाली",
  "footer_secure_system": "सुरक्षित प्रणाली",
  "hero_badge_pill": "नागरिक सेवा, अधिक सुलभ",
  "hero_title_line1": "आपला मालमत्ता कर,",
  "hero_title_line2": "आता सोपा व सुलभ.",
  "hero_subtitle": "तुमचा पुणे मालमत्ता कर ऑनलाइन शोधा, तपासा आणि भरा — तुमच्यासाठी डिझाइन केलेल्या सुरक्षित अनुभवासह.",
  "hero_secure_payments": "सुरक्षित पेमेंट",
  "hero_available_247": "२४ × ७ उपलब्ध",
  "search_card_kicker": "मालमत्ता सेवा",
  "search_card_title": "तुमची मालमत्ता शोधा",
  "search_card_subtitle": "तपशील, थकबाकी आणि भरणा इतिहास पहा.",
  "search_card_pid_label": "मालमत्ता क्रमांक (PID)",
  "search_card_pid_hint": "तुमच्या मागील मालमत्ता कर बिलावर तुमचा PID शोधा.",
  "search_card_security_check": "सुरक्षा तपासणी",
  "search_card_your_answer": "तुमचे उत्तर",
  "search_card_answer_ph": "उत्तर",
  "searching": "शोधत आहे…",
  "pid_required": "कृपया मालमत्ता क्रमांक (PID) प्रविष्ट करा",
  "pid_max_length": "मालमत्ता क्रमांक १८ अक्षरांपेक्षा जास्त नसावा",
  "feat_kicker": "सर्व काही एकाच ठिकाणी",
  "feat_heading_line1": "तुमचा मालमत्ता कर संचलित करण्याचा",
  "feat_heading_line2": "अधिक सोपा मार्ग.",
  "feat_section_subtitle": "तुमच्या पहिल्या शोधापासून ते अंतिम पावतीपर्यंत, सर्व आवश्यक सेवा स्पष्ट, जलद आणि सहज सुलभ आहेत.",
  "helpful_kicker": "मदत हवी आहे?",
  "helpful_title": "उपयुक्त लिंक्स",
  "helpful_subtitle": "सर्वात जास्त विचारल्या जाणार्‍या मालमत्ता कर सेवांमध्ये त्वरीत प्रवेश.",
  "helpful_calc_desc": "तुमच्या अंदाजित वार्षिक मालमत्ता कराचे गणन करा.",
  "helpful_track_desc": "तुमच्या नवीन कर आकारणी अर्जाची स्थिती तपासा.",
  "helpful_faqs_title": "प्रश्नोत्तरे आणि मार्गदर्शन",
  "helpful_faqs_desc": "मालमत्ता कराबाबतच्या सामान्य प्रश्नांची उत्तरे शोधा.",
  "helpline_kicker": "अधिकृत नागरिक पोर्टल",
  "helpline_title": "तुमच्या मालमत्ता कराबाबत मदत हवी आहे का?",
  "helpline_subtitle": "तुमची भरणा प्रक्रिया पूर्ण करण्यासाठी आमची हेल्पलाइन उपलब्ध आहे.",
  "helpline_btn": "संपर्क १८०० १०३० २२२",
  "search_pid_ph": "तुमचा मालमत्ता क्रमांक (PID) प्रविष्ट करा",
  "example": "उदाहरण",
  "security_check": "सुरक्षा तपासणी",
  "security_check_sub": "तुम्ही रोबोट नाही याची खात्री करण्यासाठी हे सोडवा",
  "your_answer_ph": "तुमचे उत्तर",
  "enter_answer_ph": "उत्तर प्रविष्ट करा",
  "search_property_btn": "मालमत्ता शोधा",
  "enter_pid_ph": "मालमत्ता क्रमांक (PID) प्रविष्ट करा",
  "try_another": "दुसरा प्रश्न",
  "enter_name_ph": "तुमचे पूर्ण नाव प्रविष्ट करा",
  "enter_mobile_ph": "१० अंकी मोबाइल क्रमांक प्रविष्ट करा",
  "select_subject": "विषय निवडा",
  "subj_bill": "मालमत्ता कर बिल / मूल्यांकन तक्रार",
  "subj_payment": "पेमेंट किंवा पावती समस्या",
  "subj_ownership": "नाव दुरुस्ती / मालकी हक्क हस्तांतरण",
  "subj_arv": "वार्षिक करपात्र मूल्य (ARV) वाद",
  "subj_rebate": "सवलत / सूट योजना",
  "subj_correction": "मालमत्ता तपशील दुरुस्ती",
  "subj_other": "सामान्य चौकशी / इतर",
  "message_ph": "तुमचा संदेश येथे लिहा...",
  "status_active": "सक्रिय",
  "status_inactive": "निष्क्रिय",
  "applicant_name": "अर्जदाराचे नाव",
  "applicant_mobile": "मोबाईल क्रमांक",
  "applicant_email": "ईमेल पत्ता",
  "mobile_help_text": "१० अंकी मोबाईल क्रमांक",
  "email_help_text": "उदा. name@example.com",
  "select_field": "{field} निवडा",
  "doc_upload_info": "JPG, PNG किंवा PDF · कमाल {max} MB प्रति फाईल",
  "calc_fee_pending": "अर्ज शुल्काची गणना करत आहे…",
  "fix_highlighted_errors": "कृपया पुढे जाण्यापूर्वी हायलाइट केलेल्या त्रुटी दुरुस्त करा.",
  "val_err_required": "{field} आवश्यक आहे",
  "val_err_name_len": "नाव किमान २ अक्षरांचे असणे आवश्यक आहे",
  "val_err_name_chars": "नावात फक्त अक्षरे आणि जागा असाव्यात",
  "val_err_mobile": "वैध १० अंकी मोबाईल क्रमांक प्रविष्ट करा (उदा. ९८७६५४३२१०)",
  "val_err_email": "वैध ईमेल पत्ता प्रविष्ट करा (उदा. name@example.com)",
  "val_err_number": "वैध संख्या प्रविष्ट करा",
  "val_err_negative": "मूल्य ऋण असू शकत नाही",
  "val_err_date": "वैध तारीख निवडा",
  "svc_pt5_fallback_label": "PT5 मालकी हक्क हस्तांतरण अर्ज",
  "svc_pt5_desc": "तुमच्या आकारणी झालेल्या मालमत्तेच्या मालकी हक्क हस्तांतरणासाठी अर्ज करा.",
  "chip_village_phased": "समाविष्ट गावांचे टप्प्याटप्प्याने बिलिंग",
  "chip_sra": "एसआरए सवलत",
  "chip_ff_exemption": "अग्निशामक सवलत",
};
